import React from 'react';
import { SocialSigningForm } from '@fiverr-private/identification_core';
import { useStepsContext } from '../../StepsContext';

type SocialSigningFormCoreProps = React.ComponentProps<typeof SocialSigningForm>;

export const SocialForm = () => {
    const { goToStep } = useStepsContext();

    const onEmailButtonClick: SocialSigningFormCoreProps['onEmailButtonClick'] = () => {
        goToStep('email_identification');
    };

    return (
        <SocialSigningForm
            onProfileSetup={() => goToStep('profile_setup')}
            onSocialFallback={() => goToStep('social_fallback')}
            onEmailButtonClick={onEmailButtonClick}
        />
    );
};
